export const getUrlParam = function  (name) {
  var parmsStr = window.location.search.substring(1)
  var parmsArr = parmsStr.split('&')
  var parms = {}
  for (var i = 0; i < parmsArr.length; i++) {
    parms[parmsArr[i].split('=')[0]] = parmsArr[i].split('=')[1]
  }
  return parms[name]
}




// WEBPACK FOOTER //
// ./src/common/utils/url.js